import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { FilterServiceInterface } from '../controls/advanced-gridview/services/filter-service-interface';
import { ListItem } from '../controls/filters/models/list-item';
import { DefaultHttpService } from './default-http.service';
import { MemoryService } from './memory.service';

@Injectable({
    providedIn: 'root',
})
export class FilterService extends DefaultHttpService implements FilterServiceInterface {
    constructor(
        private http: HttpClient,
        public override memoryService: MemoryService
    ) {
        super(memoryService);
    }

    Get(columnName: string): Observable<ListItem<string>[]> {
        // Appel de la Web Api
        return this.http.get<ListItem<string>[]>(this.baseUrl + '/api/filters', this.getParameterizedHttpOptions([{ key: 'columnName', value: columnName }]));
    }
}
